/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconSpades: {
  name: 'spades';
  data: string;
} = {
  name: 'spades',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M473.25 327.425c-3.297-103.283-167.005-222.847-167.005-222.847s-169.62 123.877-166.513 222.847c2.656 84.624 89.115 114.778 144.009 65.752l-48.122 115.246 141.752-.009-48.162-115.336c55.653 47.812 146.783 20.153 144.041-65.653z"/></svg>`,
};
